import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import { TaskStatus } from 'task/model/task.status';
import { TaskType } from 'task/model/task.type';
import { UserTaskExportTaskStatus } from 'user/model/user-task-export-task-status';
import { IUser } from 'user/user';

export interface IUserTaskExportTask extends IEntity {
	readonly userId: string;
	readonly exportedTasksType: TaskType;
	readonly dueTimestamp: number;
	readonly status: UserTaskExportTaskStatus;
	readonly exportedTaskStatuses: TaskStatus[];
	readonly exportedTasksDocumentUrl: string;
	readonly exportedTasksParticipantId: string;
	readonly exportedTasksParticipantName: string;
	readonly user$: Observable<IUser>;
	readonly exportedTasksParticipant$: Observable<IUser>;
}

export class UserTaskExportTask extends Entity implements IUserTaskExportTask {
	private _exportedTasksDocumentUrl: string;

	constructor(
		id: string,
		userId: string,
		exportedTasksType: TaskType,
		dueTimestamp: number,
		status: UserTaskExportTaskStatus,
		updateTimestamp: number | undefined,
		creationTimestamp: number | undefined,
		exportedTaskStatuses: TaskStatus[],
		exportedTasksDocumentUrl: string,
		exportedTasksParticipantId: string,
		exportedTasksParticipantName: string,
		user$: Observable<IUser> = of(null),
		exportedTasksParticipant$: Observable<IUser> = of(null)
	) {
		super(id, creationTimestamp, updateTimestamp);
		this._userId = userId;
		this._status = status;
		this._dueTimestamp = dueTimestamp;
		this._exportedTasksType = exportedTasksType;
		this._exportedTaskStatuses = exportedTaskStatuses;
		this._exportedTasksDocumentUrl = exportedTasksDocumentUrl;
		this._exportedTasksParticipantId = exportedTasksParticipantId;
		this._exportedTasksParticipantName = exportedTasksParticipantName;
		this._exportedTasksParticipant$ = exportedTasksParticipant$;
		this._user$ = user$;
	}

	private _exportedTasksType: TaskType;

	get exportedTasksType(): TaskType {
		return this._exportedTasksType;
	}

	private _status: UserTaskExportTaskStatus;

	get status(): UserTaskExportTaskStatus {
		return this._status;
	}

	private _userId: string;

	get userId(): string {
		return this._userId;
	}

	private _exportedTasksParticipantId: string;

	get exportedTasksParticipantId(): string {
		return this._exportedTasksParticipantId;
	}

	private _exportedTasksParticipantName: string;

	get exportedTasksParticipantName(): string {
		return this._exportedTasksParticipantName;
	}

	private _exportedTasksParticipant$: Observable<IUser>;

	get exportedTasksParticipant$(): Observable<IUser> {
		return this._exportedTasksParticipant$;
	}

	private _user$: Observable<IUser>;

	get user$(): Observable<IUser> {
		return this._user$;
	}

	get exportedTasksDocumentUrl(): string {
		return this._exportedTasksDocumentUrl;
	}

	private _dueTimestamp: number;

	get dueTimestamp(): number {
		return this._dueTimestamp;
	}
	private _exportedTaskStatuses: TaskStatus[];

	get exportedTaskStatuses(): TaskStatus[] {
		return this._exportedTaskStatuses;
	}
}
